import { LOCALE } from './format';

// Coach mode helpers shared by the coach's and the student's screens.

export const DURATIONS = [
  { id: '1_month', label: '1 tháng', months: 1 },
  { id: '3_months', label: '3 tháng', months: 3 },
  { id: 'until_cancelled', label: 'Đến khi huỷ', months: null },
];

// "26/1/2027" in Vietnam time, like the server's notifications.
export const vnDate = (iso) => (iso ? new Date(iso).toLocaleDateString(LOCALE, { day: 'numeric', month: 'numeric', year: 'numeric', timeZone: 'Asia/Ho_Chi_Minh' }) : '');
export const vnShortDate = (iso) => (iso ? new Date(iso).toLocaleDateString(LOCALE, { day: 'numeric', month: 'numeric', timeZone: 'Asia/Ho_Chi_Minh' }) : '');

export const addMonths = (date, months) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + months);
  return d;
};

// Gifts never outlast the coach's paid period.
export const giftEnd = (from, duration, periodEndsAt) => {
  const months = DURATIONS.find((d) => d.id === duration)?.months;
  const end = periodEndsAt ? new Date(periodEndsAt) : null;
  if (!months) return end;
  const own = addMonths(from, months);
  return end && end < own ? end : own;
};

export const PLAN_NOTE = 'Áp dụng khi gói HLV của bạn còn gia hạn';

export async function qrDataUrl(text, { dark = '#17201b', light = '#ffffff', width = 560 } = {}) {
  const { default: QRCode } = await import('qrcode');
  return QRCode.toDataURL(text, { width, margin: 1, color: { dark, light } });
}

// The phone's share sheet (Zalo, Messenger…); copies the link where there is none. Returns 'shared' | 'copied'.
export async function shareLink({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (e) {
      if (e?.name === 'AbortError') return null;
    }
  }
  return copyText(url);
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    window.prompt('Sao chép link này:', text);
  }
  return 'copied';
}
